import { LogOut, Bell, Menu } from 'lucide-react'
import { useAuth } from '../../hooks/useAuth'
import { useUIStore } from '../../store/uiStore'
import { getInitials } from '../../utils'
import { env } from '../../config/env'

export default function Header() {
  const { user, logout }   = useAuth()
  const toggleSidebar       = useUIStore((s) => s.toggleSidebar)
  const sidebarCollapsed    = useUIStore((s) => s.sidebarCollapsed)

  return (
    <header className="sticky top-0 z-30 h-[60px] bg-white border-b border-slate-200 flex items-center px-4 gap-4 shrink-0">
      {/* Mobile / collapsed sidebar toggle */}
      <button
        onClick={toggleSidebar}
        className="text-slate-500 hover:text-slate-800 hover:bg-slate-100 p-2 rounded-lg transition-colors lg:hidden"
        aria-label="Toggle sidebar"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* App name */}
      <span className="font-semibold text-slate-800 text-sm hidden sm:block">
        {env.appName}
      </span>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Notification bell */}
      {/* <button
        className="relative text-slate-500 hover:text-slate-800 hover:bg-slate-100 p-2 rounded-lg transition-colors"
        aria-label="Notifications"
      >
        <Bell className="h-5 w-5" />
        <span className="absolute top-1.5 right-1.5 h-2 w-2 bg-red-500 rounded-full border-2 border-white" />
      </button> */}

      {/* User info */}
      <div className="flex items-center gap-3 pl-3 border-l border-slate-200">
        <div className="hidden sm:block text-right">
          <p className="text-sm font-semibold text-slate-800 leading-tight">{user?.name}</p>
          <p className="text-xs text-slate-500 leading-tight">{user?.email}</p>
        </div>

        {/* Avatar */}
        <div className="h-8 w-8 rounded-full bg-blue-700 flex items-center justify-center text-white text-xs font-bold shrink-0">
          {getInitials(user?.name)}
        </div>

        {/* Role badge */}
        <span className="hidden md:inline-flex badge badge-info">
          {user?.role}
        </span>

        {/* Logout */}
        <button
          onClick={logout}
          className="flex items-center gap-1.5 text-slate-500 hover:text-red-600 hover:bg-red-50 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors"
          aria-label="Logout"
        >
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Logout</span>
        </button>
      </div>
    </header>
  )
}
